import { render, staticRenderFns } from "./closedIndent.vue?vue&type=template&id=df7534b8&scoped=true&"
import script from "./closedIndent.vue?vue&type=script&lang=js&"
export * from "./closedIndent.vue?vue&type=script&lang=js&"
import style0 from "./closedIndent.vue?vue&type=style&index=0&id=df7534b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7534b8",
  null
  
)

export default component.exports